"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.number.constructor");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _milkRun = require("@/mixins/milk-run/milk-run");

var _elementUi = require("element-ui");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TIME_STEPPER_KEY = 'mrTimeStepper';

var MRGanttFilterComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MRGanttFilterComponent, _Mixins);

  var _super = _createSuper(MRGanttFilterComponent);

  function MRGanttFilterComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MRGanttFilterComponent);
    _this = _super.apply(this, arguments); // @Prop({ type: String, default: null }) defaultStartDate: string;
    // @Prop({ type: String, default: null }) defaultEndDate: string;

    _this.filters = [{
      'key': 'plateNumber',
      'label': 'plateNumber'
    }, {
      'key': 'status',
      'label': 'status'
    }, {
      'key': 'truckType',
      'label': 'truckType'
    }, {
      'key': 'vehicleType',
      'label': 'vehicleType'
    }, {
      'key': 'zone',
      'label': 'zone'
    }];
    _this.switchValue = false;
    _this.selectValue = 'plateNumber';
    _this.inputValue = null;
    _this.isLocalEnableAllTrucks = true;
    _this.timeSteppers = [30, 60, 120, 240, 360];
    _this.timeStepper = 60;
    _this.routeViewOptions = ['plannedRoutes', 'suggestedRoutes', 'actualRoutes'];
    _this.routeViews = ['plannedRoutes'];
    _this.cargoTruckVal = null;
    return _this;
  } // private dateRange = null;
  // private viewType: string = 'daily';
  // private maxDays: number = 30;


  (0, _createClass2.default)(MRGanttFilterComponent, [{
    key: "onRouteViewsChanges",
    value: function onRouteViewsChanges(newVal) {
      this.$emit('onRouteViewsChanges', newVal);
    }
  }, {
    key: "onPlanDateRangeChanges",
    value: function onPlanDateRangeChanges(newVal, oldVal) {
      this.cargoTruckVal = null;
    }
  }, {
    key: "onTimeStepperChanges",
    value: function onTimeStepperChanges(newVal) {
      window.localStorage.setItem(TIME_STEPPER_KEY, newVal);
    }
  }, {
    key: "onBooleanEnableTrucksChanges",
    value: function onBooleanEnableTrucksChanges(newVal) {
      if (newVal) {
        this.$emit('onEnableAllTrucks');
        return;
      }

      this.$emit('onDisableAllTrucks');
      return;
    }
  }, {
    key: "onOrderFiltersChanges",
    value: function onOrderFiltersChanges(newVal, oldVal) {
      if (oldVal !== undefined) {
        this.$getTrucks();
      }
    }
  }, {
    key: "currentPlanOrdersLen",
    get: function get() {
      if (this.helper.isUndefined(this.$plan.orders)) {
        return 0;
      }

      return this.$plan.orders.length;
    }
  }, {
    key: "created",
    value: function created() {
      this.isLocalEnableAllTrucks = this.isEnableAllTrucks;
      this.routeViews = this.defaultRViews;
      /*if (this.defaultStartDate && this.defaultEndDate) {
        this.dateRange = [this.defaultStartDate, this.defaultEndDate];
      } else {
        this.dateRange = [
          moment(new Date()).format('YYYY-MM-DD'),
          moment(new Date()).format('YYYY-MM-DD')
        ];
      }*/

      /*if (this.isAutoAssign) {
        this.filters.unshift({ 'key': 'status', 'label': 'status' });
      }*/

      var timeStepper = window.localStorage.getItem(TIME_STEPPER_KEY);

      if (!this.helper.isUndefined(timeStepper)) {
        this.timeStepper = Number(timeStepper);
        this.handleTimeStepperChanges(this.timeStepper);
      }
    }
  }, {
    key: "handleCloseTag",
    value: function handleCloseTag(filter) {
      if (filter) {
        var index = this.helper.findIndex(this.$truckFilters, {
          'key': filter.key,
          'value': filter.value
        });
        var tmpArr = this.helper.cloneDeep(this.$truckFilters);
        tmpArr.splice(index, 1);
        this.$truckFilters = tmpArr;
      }
    }
  }, {
    key: "addFilter",
    value: function addFilter() {
      var _this2 = this;

      var isBoolean = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (/\S/.test(this.inputValue) || isBoolean) {
        var index = this.helper.findIndex(this.$truckFilters, {
          'key': this.selectValue,
          'value': this.inputValue
        });

        if (index === -1) {
          var filter = {
            'key': this.selectValue,
            'label': this.helper.get(this.helper.find(this.filters, {
              'key': this.selectValue
            }), 'label', ''),
            'value': this.inputValue
          };
          var filters = (0, _toConsumableArray2.default)(this.$truckFilters);

          if (!isBoolean) {
            filters.push(filter);
          }

          if (isBoolean && !this.helper.isUndefined(this.selectValue)) {
            var filterIndex = this.helper.findIndex(filters, function (f) {
              return f['label'] === _this2.selectValue;
            });

            switch (this.selectValue) {
              case 'status':
                filter['value'] = this.switchValue ? 'Enabled Trucks' : 'Disabled Trucks';
                break;
              // case 'offDuty':
              //   filter['key'] = 'drivers.offDuty';
              //   filter['value'] = this.switchValue ? '1' : '0';
              // break;
            }

            if (filterIndex !== -1) {
              filters[filterIndex] = filter;
            } else {
              filters.push(filter);
            }
          }

          this.$truckFilters = filters;
        }
      }

      this.inputValue = '';
    }
  }, {
    key: "handleTimeStepperChanges",
    value: function handleTimeStepperChanges(newVal) {
      this.$emit('onTimeStepperChanges', newVal);
    }
    /*isValidDateRange(dateRange) {
      const startDate = moment(dateRange[0]);
      const endDate = moment(dateRange[1]);
      const duration = (moment.duration(endDate.diff(startDate))).asDays();
         if (duration > this.maxDays) {
        const message: ElNotificationOptions = {
          title: this.$i18n.t('general.queryExceed1Week'),
          duration: 5000
        } as ElNotificationOptions;
           Notification.error(message);
        return false;
      }
         return true;
    }*/

  }, {
    key: "handlePlay",
    value: function handlePlay() {
      this.$emit('onGCPlay');
    }
  }, {
    key: "handlePause",
    value: function handlePause() {
      this.$emit('onGCPause');
    }
  }, {
    key: "handleTruckHasCargo",
    value: function handleTruckHasCargo(newVal) {
      var _this3 = this;

      if (newVal === null) {
        this.$trucks = this.helper.cloneDeep(this.$bufferTrucks);
      } else if (newVal === 'nonEmptyTrucks') {
        this.$trucks = this.$bufferTrucks.filter(function (truck) {
          return !!_this3.$plan.trucks.find(function (t) {
            return t.truckId === truck['id'];
          });
        });
      } else {
        this.$trucks = this.$bufferTrucks.filter(function (truck) {
          return !_this3.$plan.trucks.find(function (t) {
            return t.truckId === truck['id'];
          });
        });
      }

      this.$selectedTruck = null;
    }
  }]);
  return MRGanttFilterComponent;
}((0, _vuePropertyDecorator.Mixins)(_milkRun.MilkRunMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttFilterComponent.prototype, "isAutoAssign", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: true
})], MRGanttFilterComponent.prototype, "isEnableAllTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Array,
  default: ['plannedRoutes']
})], MRGanttFilterComponent.prototype, "defaultRViews", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttFilterComponent.prototype, "isVerticallyAutoScrolling", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttFilterComponent.prototype, "isDashboard", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: true
})], MRGanttFilterComponent.prototype, "isPlay", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttFilterComponent.prototype, "isPause", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('routeViews')], MRGanttFilterComponent.prototype, "onRouteViewsChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$planDateRange')], MRGanttFilterComponent.prototype, "onPlanDateRangeChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('timeStepper')], MRGanttFilterComponent.prototype, "onTimeStepperChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isLocalEnableAllTrucks')], MRGanttFilterComponent.prototype, "onBooleanEnableTrucksChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$truckFilters', {
  deep: true,
  immediate: true
})], MRGanttFilterComponent.prototype, "onOrderFiltersChanges", null);
MRGanttFilterComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MRGanttFilterComponent',
  components: {
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-tag': _elementUi.Tag,
    'el-input': _elementUi.Input,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-switch': _elementUi.Switch,
    'el-button': _elementUi.Button,
    'el-tooltip': _elementUi.Tooltip,
    'el-date-picker': _elementUi.DatePicker
  }
})], MRGanttFilterComponent);
var _default = MRGanttFilterComponent;
exports.default = _default;